const MC_BASE = 'https://herbirthkeeper.us12.list-manage.com/subscribe/post-json'
const MC_U = 'a5fa85706ce6f923885e24c5b'
const MC_ID = '41033af8eb'
const MC_F_ID = '0022eae0f0'
const MC_HONEYPOT = `b_${MC_U}_${MC_ID}`

interface McResponse {
  result: 'success' | 'error'
  msg: string
}

export function subscribeToMailchimp(email: string, fname = ''): Promise<McResponse> {
  return new Promise((resolve, reject) => {
    const cbName = `_mc_${Date.now()}`

    const params = new URLSearchParams({
      u: MC_U,
      id: MC_ID,
      f_id: MC_F_ID,
      EMAIL: email,
      FNAME: fname,
      [MC_HONEYPOT]: '',
      c: cbName,
    })

    const script = document.createElement('script')
    script.src = `${MC_BASE}?${params}`

    const timer = setTimeout(() => {
      cleanup()
      reject(new Error('timeout'))
    }, 10_000)

    function cleanup() {
      clearTimeout(timer)
      delete (window as unknown as Record<string, unknown>)[cbName]
      script.parentNode?.removeChild(script)
    }

    ;(window as unknown as Record<string, unknown>)[cbName] = (res: McResponse) => {
      cleanup()
      resolve(res)
    }

    script.onerror = () => {
      cleanup()
      reject(new Error('network'))
    }

    document.body.appendChild(script)
  })
}
